/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { TimeZoneParameterFormModel, TimeZoneReportParameterValue } from '../models/time-zone-parameter-value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: TimeZoneReportParameterComponent }],
    selector: 'ndt-time-zone-report-parameter',
    templateUrl: './time-zone-report-parameter.component.html',
    standalone: false
})
export class TimeZoneReportParameterComponent implements OnDestroy {
   config: ReportParameterConfig;

   set form(form: UntypedFormGroup) {
      this._form = form;
      const formValue: TimeZoneParameterFormModel = this.form.value;
      if (formValue) {
         this.initializeContentFormValue(formValue);
      }
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   private initializeContentFormValue(formValue: TimeZoneReportParameterValue): void {
      if (typeof this.form.value.value !== 'object') {
         this.form.setValue({
            ...formValue,
            value:
               formValue.value !== ''
                  ? {
                       DisplayName: formValue.value,
                       timeZoneId: formValue.value,
                    }
                  : '',
         });
      }
   }
}
